module.exports = __webpack_public_path__ + "static/media/vf_msneakers_core.dc7e3db5.svg";